import { Box, BoxProps, Stack, Typography, useTheme } from "@mui/material";

import { Divider } from "@/Components/v2/atoms/Divider";
import { formatPercentageFromFraction } from "@/pages/scenario-builder/utils/formatPercentage";
import { isDefined } from "@/Utils/array-utils";

import { FunnelStageData } from "../../../utils/getFunnelStageBreakdown";

interface FunnelStageCardProps extends BoxProps, FunnelStageData {
  summaryFormatter: (value: number) => string;
}

export const FunnelStageCard = ({
  stage,
  spend,
  revenue,
  roi,
  spendPercentage,
  revenuePercentage,
  summaryFormatter,
  ...boxProps
}: FunnelStageCardProps) => {
  const theme = useTheme();
  const formattedROI = isDefined(roi) ? formatPercentageFromFraction(roi) : "-";

  return (
    <Box
      border={`1px solid ${theme.palette.section.border}`}
      p={2}
      borderRadius={3}
      height="100%"
      {...boxProps}
    >
      <Stack spacing={2} height="100%" justifyContent="space-between">
        {/* Top section - Stage Marketing and ROI */}
        <Stack spacing={0.5}>
          <Typography variant="body2" fontWeight={600}>
            {stage}
          </Typography>
          <Typography variant="body1" fontWeight={100}>
            {formattedROI} ROI
          </Typography>
        </Stack>

        <Divider />

        {/* Bottom section - Spend and Revenue in two columns */}
        <Stack direction="row" spacing={3}>
          <Stack flex={1} alignItems="left">
            <Typography variant="body2" fontWeight={600}>
              Spend
            </Typography>
            <Typography variant="body1" fontWeight={100}>
              {summaryFormatter(spend)} ({Math.round(spendPercentage * 100)}%)
            </Typography>
          </Stack>

          <Stack flex={1} alignItems="left">
            <Typography variant="body2" fontWeight={600}>
              Revenue
            </Typography>
            <Typography variant="body1" fontWeight={100}>
              {summaryFormatter(revenue)} ({Math.round(revenuePercentage * 100)}%)
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
